export const servicesEngagementData = {
  heading: "How We Work With You",
  subtext:
    "Choose the engagement model that fits your project size, timeline and budget. Every model is backed by the same engineering quality.",
  cta: "Discuss Your Project",
  items: [
    {
      title: "Project-Based Development",
      highlight: "Fixed Scope",
      icon: "ri-folder-line",
      bestFor: "Clearly defined projects with specific scope and deliverables.",
      engagement: "Fixed-price or milestone-based billing with a defined timeline.",
      benefits: [
        "Predictable budget and timeline",
        "Clear deliverables and scope",
        "Full project ownership",
      ],
    },
    {
      title: "Dedicated Developer",
      highlight: "Monthly",
      icon: "ri-user-star-line",
      bestFor: "Teams needing a senior Laravel developer as an extension of their team.",
      engagement: "Monthly retainer with flexible hours and direct collaboration.",
      benefits: [
        "A dedicated senior resource",
        "Seamless team integration",
        "Flexible, long-term engagement",
      ],
    },
    {
      title: "Dedicated Development Team",
      highlight: "Full Team",
      icon: "ri-team-line",
      bestFor: "Startups and businesses building complex digital products end-to-end.",
      engagement: "A full cross-functional team working exclusively on your product.",
      benefits: [
        "Complete product team",
        "Design, development and DevOps",
        "Built for scale and speed",
      ],
    },
    {
      title: "Long-Term Support",
      highlight: "Ongoing",
      icon: "ri-heart-3-line",
      bestFor: "Products that need ongoing maintenance, monitoring and improvement.",
      engagement: "Monthly retainer with defined SLAs and continuous delivery.",
      benefits: [
        "Proactive maintenance",
        "Security and performance care",
        "A reliable long-term partner",
      ],
    },
  ],
};